var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76569 0.234315C8.07811 0.546734 8.07811 1.05327 7.76569 1.36569L3.49902 5.63235C3.1866 5.94477 2.68007 5.94477 2.36765 5.63235L0.234315 3.49902C-0.0781049 3.1866 -0.0781049 2.68007 0.234315 2.36765C0.546734 2.05523 1.05327 2.05523 1.36569 2.36765L2.93333 3.9353L6.63431 0.234315C6.94673 -0.0781049 7.45327 -0.0781049 7.76569 0.234315Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckIcon);
export default __webpack_public_path__ + "static/media/uncheck-icon.6f0d6b7e.svg";
export { ForwardRef as ReactComponent };